import FroalaEditor from "froala-editor";
import "froala-editor/js/plugins/align.min.js";
import "froala-editor/js/plugins/lists.min.js";
import "froala-editor/js/plugins/link.min.js";
import "froala-editor/js/plugins/image.min.js";
import "froala-editor/js/plugins/paragraph_format.min.js";
import "froala-editor/js/plugins/font_size.min.js";
import "froala-editor/js/plugins/line_height.min.js";
import { froalaKey } from "src/froala_license";

export { FroalaEditor };

export function initTemplateEditor(element, options = {}) {
  return new FroalaEditor(element, {
    key: froalaKey(),
    attribution: false,
    ...options,
  });
}
